/* eslint-disable */
import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { KINESIS_STREAM_VIEW_RENTAL_PLAN } from 'ggApp/modules/tracking/constants';
import {
    selectedRentalPlanSelector as currentRentalPlanSelector,
} from 'ggApp/modules/rentalPlan/selectors';
import { storeActive } from 'ggApp/modules/store/selectors';
import {
    user as userSelector,
} from 'ggApp/modules/auth/selectors';
import { sendEvent as sendViewEvent } from 'ggApp/modules/tracking/actions';
import { rentalPlanView } from 'ggApp/modules/tracking/selectors';
import { currentProduct } from 'ggApp/modules/product/selectors';

const defaultOptions = {
    productSelector: currentProduct,
    selectedRentalPlanSelector: currentRentalPlanSelector,
};

const viewPlanEventSender = (options = defaultOptions) => (WrappedComponent) => {
    const {
        productSelector,
        selectedRentalPlanSelector,
    } = options;

    @connect(createStructuredSelector({
        hocStore: storeActive,
        hocUser: userSelector,
        hocProduct: productSelector,
        hocSelectedPlan: selectedRentalPlanSelector,
    }), dispatch => ({
        hocSendEvent: bindActionCreators(sendViewEvent, dispatch),
    }))
    class ViewPlanEventSender extends Component {
        static propTypes = {
            hocStore: PropTypes.shape({}),
            hocUser: PropTypes.shape({}),
            hocProduct: PropTypes.shape({}),
            hocSelectedPlan: PropTypes.shape({
                planId: PropTypes.number,
            }),
            hocSendEvent: PropTypes.func,
        }

        static defaultProps = {
            hocStore: {},
            hocUser: {},
            hocProduct: {},
            hocSelectedPlan: {},
            hocSendEvent: () => undefined,
        }

        static displayName = `WithViewPlanEventSender(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`

        componentDidMount() {
            this.sendViewPlanEvent();
        }

        componentDidUpdate(prevProps) {
            const { hocSelectedPlan: currentHocSelectedPlan } = this.props;

            if (prevProps.hocSelectedPlan.planId !== currentHocSelectedPlan.planId) {
                this.sendViewPlanEvent();
            }
        }

        sendViewPlanEvent = () => {
            const {
                hocStore,
                hocUser,
                hocProduct,
                hocSelectedPlan,
                hocSendEvent,
            } = this.props;


            hocSendEvent(KINESIS_STREAM_VIEW_RENTAL_PLAN, rentalPlanView({
                user: hocUser,
                store: hocStore,
                product: hocProduct,
                plan: hocSelectedPlan,
            }));
        }

        render() {
            const {
                hocStore,
                hocUser,
                hocProduct,
                hocSelectedPlan,
                hocSendEvent,
                ...props
            } = this.props;

            return <WrappedComponent {...props} />;
        }
    }

    return ViewPlanEventSender;
};

export { viewPlanEventSender };
